import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/videos';

const imageUrls: Record<string, string> = {
  'mountains-call': 'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20Chinese%20drama%20set%20in%20Yunnan%20mountain%20village%2C%20warm%20atmospheric%20lighting%2C%20elderly%20teacher%20in%20rural%20school%2C%20golden%20hour%20sunlight%2C%20professional%20cinematography%2C%20emotional%20storytelling&width=800&height=450&seq=featured-mountains-call&orientation=landscape',
  'tech-future': 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20AI%20research%20laboratory%20with%20futuristic%20technology%2C%20warm%20ambient%20lighting%2C%20scientists%20working%20on%20computers%2C%20clean%20minimal%20aesthetic%2C%20professional%20documentary%20style&width=800&height=450&seq=featured-tech-future&orientation=landscape',
  'city-laugh': 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20office%20comedy%20scene%20with%20young%20professionals%20in%20bright%20workspace%2C%20warm%20and%20playful%20atmosphere%2C%20natural%20light%20through%20large%20windows%2C%20vibrant%20urban%20lifestyle&width=800&height=450&seq=featured-city-laugh&orientation=landscape',
  'silk-road': 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20shot%20of%20ancient%20Silk%20Road%20landscape%20in%20western%20China%2C%20vast%20desert%20with%20caravan%20trail%2C%20warm%20golden%20sunset%20light%2C%20epic%20scale%2C%20professional%20nature%20photography&width=800&height=450&seq=featured-silk-road&orientation=landscape',
  'ink-soul': 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20animation%20scene%2C%20traditional%20watercolor%20landscape%20with%20soft%20brush%20strokes%2C%20elegant%20mountain%20and%20river%20composition%2C%20artistic%20abstract%20beauty%2C%20warm%20paper%20texture&width=800&height=450&seq=featured-ink-soul&orientation=landscape',
  'taste-home': 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20home%20kitchen%20scene%20with%20family%20cooking%20together%2C%20steaming%20traditional%20dishes%2C%20cozy%20atmosphere%20with%20soft%20ambient%20lighting%2C%20authentic%20cultural%20documentary%20style&width=800&height=450&seq=featured-taste-home&orientation=landscape',
};

export default function FeaturedSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8 md:mb-12">
            <div>
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
                精选推荐
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                本周必看佳作
              </h2>
              <p className="text-sm text-foreground-500 mt-2 max-w-lg">
                编辑团队精心挑选的本周最值得观看的国产原创视频内容
              </p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredVideos.slice(0, 6).map((video) => (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group bg-background-100/70 rounded-xl overflow-hidden transition-all duration-300 hover:bg-background-100 cursor-pointer no-underline"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={imageUrls[video.id]}
                    alt={video.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-foreground-800">
                      {video.categoryName}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-0.5 bg-black/60 backdrop-blur-sm rounded text-xs text-background-50">
                      {video.duration}
                    </span>
                  </div>
                  <div className="absolute bottom-3 left-3 flex items-center gap-1.5">
                    <span className="flex items-center gap-1 text-xs text-accent-400 font-semibold">
                      <i className="ri-star-fill text-amber-400"></i>
                      {video.rating}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-1">
                    {video.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {video.description}
                  </p>
                  <div className="flex items-center gap-2 flex-wrap">
                    {video.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="mt-3 pt-3 border-t border-background-200/60 flex items-center gap-3 text-xs text-foreground-400">
                    <span>{video.director} 导演</span>
                    <span>{video.year}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}